import React from 'react';
import { MetricCell } from './hoshinShared';

interface HoshinExecutiveStripProps {
  objectives: number;
  goals: number;
  goalsWithoutWork: number;
  overdueActions: number;
}

export const HoshinExecutiveStrip: React.FC<HoshinExecutiveStripProps> = ({
  objectives,
  goals,
  goalsWithoutWork,
  overdueActions,
}) => {
  return (
    <div className="grid grid-cols-2 border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900 md:grid-cols-4">
      <MetricCell label="Objetivos" value={objectives} />
      <MetricCell label="Metas de setor" value={goals} />
      <MetricCell
        label="Sem ação"
        value={goalsWithoutWork}
        tone={goalsWithoutWork > 0 ? 'warning' : 'default'}
        sub={goalsWithoutWork > 0 ? 'Ainda sem trabalho ligado' : 'Todas com ação'}
      />
      <MetricCell
        label="Ações atrasadas"
        value={overdueActions}
        tone={overdueActions > 0 ? 'danger' : 'default'}
        sub={overdueActions > 0 ? 'Prazo da ação vencido' : 'Nenhuma atrasada'}
      />
    </div>
  );
};
